module.exports = __webpack_public_path__ + "static/media/leaderboard-img7.2479255d.jpeg";